// Convert to German Date
export function date(date, style) {
  let options = {
    dateStyle: !style ? "medium" : style,
  };
  const event = new Date(date);
  return event.toLocaleDateString("de-DE", options);
}
